import React from 'react'

import { P } from '@mxenabled/mxui'

// TODO : Import Timeline Components from core when they are available
import TimelineConnector from '@mui/lab/TimelineConnector'
import TimelineContent from '@mui/lab/TimelineContent'
import TimelineDot from '@mui/lab/TimelineDot'
import TimelineSeparator from '@mui/lab/TimelineSeparator'
import TimelineItem from '@mui/lab/TimelineItem'

interface ScoreHistoryTimelineItemProps {
  content?: string
  islast?: boolean
}

const ScoreHistoryTimelineItem: React.FC<ScoreHistoryTimelineItemProps> = ({
  content,
  islast = false,
}) => {
  return (
    <TimelineItem sx={{ minHeight: 0 }}>
      <TimelineSeparator>
        <TimelineDot sx={{ bgcolor: 'divider', boxShadow: 'none', p: 2 }} />
        {!islast && (
          <TimelineConnector
            sx={{
              bgcolor: 'background.paper',
              borderLeft: '1px solid',
              borderColor: 'divider',
              borderRadius: 1,
              m: -4,
            }}
          />
        )}
      </TimelineSeparator>
      <TimelineContent sx={{ pb: 16, pl: 12, pr: 0, pt: 5 }}>
        <P fontSize={13} fontWeight={400} variant="subtitle2">
          {content}
        </P>
      </TimelineContent>
    </TimelineItem>
  )
}

export default ScoreHistoryTimelineItem
